import type { MatchesById } from 'app/lib/betting/betting-entities/reducers/matches/types';

import {
  getIsValidMatchForTimeFilter,
} from 'app/redux/betting-presentation/grid/utils/get-is-valid-match-for-time-filter';

export type MatchesBySportId = Record<string, Set<number>>;

export const getFilteredMatchesByTimeFilter = (
  matches: MatchesById,
  interval: number,
) => {
  const dateWithFilter = new Date().getTime() + interval * 60 * 1000;

  const filteredMatches = matches.reduce((acc, match) => {
    const isValidMatch = getIsValidMatchForTimeFilter(match, dateWithFilter);
    if (isValidMatch && !acc[match.sportId]) {
      acc[match.sportId] = new Set([match.id]);
    }

    if (isValidMatch && acc[match.sportId]) {
      acc[match.sportId].add(match.id);
    }

    return acc;
  }, {} as MatchesBySportId);

  return filteredMatches;
};
